import useArticleImportRequest from "../useArticleImportRequest";
import React, { useState } from 'react';
import apiUrl from '../../Apiurl';
import stilePulsanti from '../../interfaccia/stilePulsanti';

function CSVDatiUlteriori(props) {
  const uploadArticleCsv = useArticleImportRequest(props.utente);


  const [selectedFile, setSelectedFile] = useState();
  const [varQuery1, setVarQuery1] = useState("26000");
  const [varQuery2, setVarQuery2] = useState("27001");
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [risultatoOperazione, setRisultatoOperazione] = useState("In attesa dell'upload");

  const {
    inputClassesConTasto,
    classiTastoSblocco,
    tastoCopiaAspetto,
    buttonClassesWhite
  } = stilePulsanti

  const handleChange = async function (evt) {
    const value = evt.target.value;
    try {
      if (evt.target.name === "varQuery1") {
        setVarQuery1(value);
      }
      if (evt.target.name === "varQuery2") {
        setVarQuery2(value);
      }
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
      throw err;
    }
  }

  const query = `SELECT ALL 
    raggruppativi.[CodiceArticolo] as 'codVS'
   ,tend.[idGruppoPS] as 'idDato'
   ,tutto.[sezFontina] as 'sez'
   ,tutto.[tabFontina] as 'tab'
   ,tutto.[datoFontina] as 'dato'
   ,b.[idPS_associato] as 'valueID'
   ,'' as 'valueDesc'
 FROM [DD_VIGLIETTISEDE].[dbo].[tabDatiUlteriori_Dati] a  

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[tabArticoli] raggruppativi
 ON raggruppativi.[idArticolo] = a.[idRiferimento]

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[DAM_congDatiPersonalizzatiConvertitiInTendina] b
 ON b.[id]=a.[id]

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Tendina] tend
 ON a.[idDefinizioneDatoUlteriore]=tend.[idGruppo2bit]

 LEFT JOIN (SELECT ALL * FROM (SELECT [id_dato_2bit],[tabFontina],[sezFontina],[datoFontina] FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Tutto] WHERE [id_dato_2bit] IS NOT NULL) x
GROUP BY [id_dato_2bit],[tabFontina],[sezFontina],[datoFontina]) tutto
ON a.[idDefinizioneDatoUlteriore]=tutto.[id_dato_2bit]
 
 /*filtro dati testo convertiti in tendina*/
 WHERE a.[idDefinizioneDatoUlteriore] in (SELECT [idDefinizioneDatoUlteriore] FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDatiPersonalizzatiConvertitiInTendina]) AND

 ((a.[ValoreText] <> '' AND a.[ValoreText] <> ' ') or (a.[ValoreLong] <> 0)) AND raggruppativi.[idArticolo] > '${varQuery1}' and raggruppativi.[idArticolo] < '${varQuery2}'

UNION ALL

 SELECT ALL 
    raggruppativi.[CodiceArticolo] as 'codVS'
   ,tend.[idGruppoPS] as 'idDato'
   ,tend.[sez] as 'sez'
   ,tend.[tab] as 'tab'
   ,tend.[dato] as 'dato'
   /*,b.[idPS_associato] as 'valueID'*/
   ,'' as 'valueID'	  
   ,a.[ValoreText] as 'valueDesc'
 FROM [DD_VIGLIETTISEDE].[dbo].[tabDatiUlteriori_Dati] a

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[tabArticoli] raggruppativi
  ON raggruppativi.[idArticolo] = a.[idRiferimento]
 
 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Testo] tend
 ON a.[idDefinizioneDatoUlteriore]=tend.[idGruppo2bit]
 
 /*filtro dati testo*/
 WHERE a.[idDefinizioneDatoUlteriore] IN (SELECT [idGruppo2bit] FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Testo]) 
 
 AND ((a.[ValoreText] <> '' AND a.[ValoreText] <> ' ') or (a.[ValoreLong] <> 0)) AND raggruppativi.[idArticolo] > '${varQuery1}' and raggruppativi.[idArticolo] < '${varQuery2}'

 UNION ALL

SELECT ALL 
    raggruppativi.[CodiceArticolo] as 'codVS'
   ,tend.[idGruppoPS] as 'idDato'
   ,tutto.[sezFontina] as 'sez'
   ,tutto.[tabFontina] as 'tab'
   ,tutto.[datoFontina] as 'dato'
   ,tend.[idDatoPS] as 'valueID'
   ,'' as 'valueDesc'
 FROM [DD_VIGLIETTISEDE].[dbo].[tabDatiUlteriori_Dati] a

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[tabArticoli] raggruppativi
  ON raggruppativi.[idArticolo] = a.[idRiferimento]

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[DAM_congDatiPersonalizzatiConvertitiInTendina] b
 ON b.[id]=a.[id]
 
 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[tabDatiUlteriori_datiPredefiniti] c
 ON c.[id]=a.[ValoreLong]

 LEFT JOIN [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Tendina] tend
 ON c.[id]=tend.[idDato2bit]

 
 LEFT JOIN (SELECT ALL * FROM (SELECT [id_dato_2bit],[tabFontina],[sezFontina],[datoFontina] FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Tutto] WHERE [id_dato_2bit] IS NOT NULL) x
GROUP BY [id_dato_2bit],[tabFontina],[sezFontina],[datoFontina]) tutto
ON a.[idDefinizioneDatoUlteriore]=tutto.[id_dato_2bit]
 
 /*filtro dati tendina*/
 WHERE a.[idDefinizioneDatoUlteriore] NOT IN (SELECT CAST([idDefinizioneDatoUlteriore] as int) FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDatiPersonalizzatiConvertitiInTendina] WHERE [idDefinizioneDatoUlteriore] IS NOT NULL) 

 AND a.[idDefinizioneDatoUlteriore] NOT IN (SELECT CAST([idGruppo2bit] as int) FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Testo] WHERE [idGruppo2bit] IS NOT NULL)
 
 AND a.[idDefinizioneDatoUlteriore] IN (SELECT [id_dato_2bit] FROM [DD_VIGLIETTISEDE].[dbo].[DAM_congDU_Tutto] WHERE [id_dato_2bit] IS NOT NULL)
 
 AND ((a.[ValoreText] <> '' AND a.[ValoreText] <> ' ') or (a.[ValoreLong] <> 0) AND c.[ValoreText] <> 'NULL') AND raggruppativi.[idArticolo] > '${varQuery1}' and raggruppativi.[idArticolo] < '${varQuery2}'`


  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const handleSubmission = () => {
    const formData = new FormData();

    formData.append('uploaded_file', selectedFile);

    uploadArticleCsv(apiUrl + "/csv/datiUlteriori", formData)
      .then((result) => {
        setRisultatoOperazione("Dati caricati correttamente")
        console.log('Success:', result);
      })
      .catch((error) => {
        setRisultatoOperazione(error.message);
          console.error('Error:', error);
      });
  };


  return (
    <div className='flex colonnaTuttaPagina'>
      <div className="w-30 fr pl4 pr4 ">
        <h1>Dati Ulteriori</h1>
        <p>Specifica i codici VS da includere, esegui la query qui a fianco nel database di 2bit e carica il csv dei risultati.</p>
        <p>ATTENZIONE: è previsto che il csv sia senza headers (come lo si ottiene cliccando con il dx e facendo save results)</p>
        <p>Esporta da codice: (escluso)</p>
        <input
          type="text"
          id="varQuery1"
          name="varQuery1"
          value={varQuery1}
          onChange={handleChange}
          className={inputClassesConTasto}
        />
        <p>A codice: (escluso)</p>
        <input
          type="text"
          id="varQuery2"
          name="varQuery2"
          value={varQuery2}
          onChange={handleChange}
          className={inputClassesConTasto}
        />

        <br />
        <br />
        <br />
        <br />
        <input type="file" accept="csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div>
            <p>Nome del file: {selectedFile.name}</p>
            <p>Tipo file: {selectedFile.type}</p>
            <p>Dimensione in bytes: {selectedFile.size}</p>
            <p>
              Data ultima modifica:{' '}
              {selectedFile.lastModifiedDate.toLocaleDateString()}
            </p>
          </div>
        ) : (
          <p>Seleziona un file</p>
        )}
        <div>
          <button onClick={handleSubmission} className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center">Carica</button>
        </div>
        <p>{risultatoOperazione}</p>
      </div>
      <div className="w-70 fr sezioneConScroll colonna90vh">
        <div className='pa4'>
          <span><button onClick={(e) => navigator.clipboard.writeText(query).then(e.preventDefault())} className={buttonClassesWhite}>{tastoCopiaAspetto}</button></span><span>Copia la query in clipboard</span>
        </div>
        <pre>
          {query}
        </pre>
      </div>
    </div>


  )

}





export default CSVDatiUlteriori;